module.exports = __webpack_public_path__ + "img/fi-rr-pause.0ff5e77d.svg";